import { h } from "preact";

import { Variable, VariableCollection, VariableMode } from "../../foundation/api/model/variables/Variables";
import { PLATFORM } from "../../foundation/enums";
import BasicRecord from "../../foundation/utils/BasicRecord";

import VariableGroupSection from "./VariableGroupSection/VariableGroupSection";

interface Props {
    variableCollections: VariableCollection[];
    variableModeIdMap: BasicRecord<VariableMode>;
    sourceIdVariableMap: BasicRecord<Variable>;
    platform: PLATFORM;
    collapsedSections: BasicRecord<boolean>;
    canManageColors: boolean;
    onAttemptToChange: () => void | null;
    onCollapseSection: (ids: string[]) => void;
    onExpandSection: (ids: string[]) => void;
}

function VariablesContainer({
    variableCollections,
    variableModeIdMap,
    sourceIdVariableMap,
    platform,
    collapsedSections,
    canManageColors,
    onAttemptToChange,
    onCollapseSection,
    onExpandSection
}: Props) {
    return variableCollections.flatMap(collection =>
        collection.groups
            .filter(group => group.isDefault || group.variables.length > 0)
            .map(group => (
                <VariableGroupSection
                    key={group._id}
                    platform={platform}
                    collapsedSections={collapsedSections}
                    variableModeIdMap={variableModeIdMap}
                    sourceIdVariableMap={sourceIdVariableMap}
                    collection={collection}
                    group={group}
                    canManageColors={canManageColors}
                    onAttemptToChange={onAttemptToChange}
                    onCollapse={onCollapseSection}
                    onExpand={onExpandSection}/>
            )));
}

export default VariablesContainer;
